<section id="footer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="item-header">
                    <h4>Kapcsolat</h4>
                    <hr/>
                </div>
                <div class="item-body">
                    <p>Magánszemélyek és céges ügyfelek megkeresését is várjuk. Kérdés vagy megrendelési igény esetén vegye fel velünk a kapcsolatot bármely elérhetőségünkön.</p>
                </div>
                <div class="item-footer">
                    <ul>
                        <li><fa-icon [icon]="icons.mapMarker"></fa-icon>1118 Budapest, Nándorfejérvári út 33. fsz. 2.</li>
                        <li><fa-icon [icon]="icons.phone"></fa-icon>+36/20-444-2211</li>
                        <li><fa-icon [icon]="icons.envelope"></fa-icon>support@general-track.com</li>
                    </ul>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="item-header">
                            <h4>Hasznos linkek</h4>
                            <hr/>
                        </div>
                        <div class="item-body">
                            <ul>
                                <li><a href="aszf.html" target="_blank">Általános szerződési feltételek</a></li>
                                <li><a href="aszf.html#nyolc" target="_blank">Adatvédelmi nyilatkozat</a></li>
                                <li><a href="aszf.pdf" target="_blank" download><fa-icon [icon]="icons.download"></fa-icon>ÁSZF letöltése</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="item-header">
                            <h4>Mobil Alkalmazás</h4>
                            <hr/>
                        </div>
                        <div class="item-body">
                            <ul>
                                <li>
                                    <a href="https://play.google.com/store/apps/details?id=hu.generalmechatronics.trackerapp" target="_blank">
                                        <img src="assets/images/google.svg" class="anim-pulse" alt="Google Play"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://itunes.apple.com/us/app/general-track/id1353012691?ls=1&mt=8">
                                        <img src="assets/images/apple.svg" class="anim-pulse" alt="AppStore"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<footer>
    <p>2020 &copy; Minden jog fenntartva</p>
</footer>
